/**
 * NAV-1 — the W.1 tools and the one place that knows where each one opens.
 *
 * The Work Table home drew this list and worked out these routes; the rail's
 * flyout has to open the same tool the same way, so the list and the routing
 * live here and both read them. Nobody keeps a second copy.
 */

// name, letter, colour token, one-line description, mark shape, key
export const TOOLS = [
  // NM-1 — the tool is called Dreamcasting. Its key, its colour token and its
  // route are untouched; only the name and the mark letter are read by anyone.
  ['Dreamcasting', 'D', '--km-tool-yard', 'Gather anything, arrange it freely', 'sq', 'yard'],
  ['Mood Board', 'M', '--km-tool-mood', 'Arrange and present for approval', 'sq', 'mood'],
  ['Palette', 'P', '--km-tool-palette', 'Colour and material schemes', 'sq', 'palette'],
  ['TakeOff', 'T', '--km-tool-takeoff', 'Mark products on the drawing', 'sq', 'takeoff'],
  ['Assemblies', 'A', '--km-tool-assemblies', 'Build methods and their products', 'sq', 'assemblies'],
  ['Studio', 'S', '--km-tool-studio', 'Compose and render', 'sq', 'studio'],
  ['QR', 'Q', '--km-tool-qr', 'Codes that open a place on site', 'sq', 'qr'],
  ['Design Assistant', 'D', '--km-tool-assistant', 'Ask, compare, decide', 'round', 'assistant'],
  ['Process Map', 'R', '--km-tool-process', 'Map the plan set, step by step', 'sq', 'process'],
  ['Pre Engineering', 'E', '--km-tool-preeng', 'Structure and systems, early', 'sq', 'preeng'],
  ['Portfolio', 'F', '--km-tool-portfolio', 'The finished work, presented', 'sq', 'portfolio'],
];

// Chad's spec dims these two. The rest are dimmed only when no route exists.
export const COMING = ['preeng', 'portfolio'];

/* Real destinations only. WorkTablePage.js already accepts ?mode= for four of its
   tools (WorkTablePage.js:154 reads modeParam and honours moodboard, takeoff,
   palette, studio) so those are reachable without touching that file. QR has its
   own route. Design Assistant and Process Map are in-page tabs with NO url entry
   DP68 — ?mode= turned out to already exist and already work; the only fault
   was that its mode whitelist named four of the six tool modes. Design
   Assistant and Process Map now have real routes and are live tiles. */
export function routesForYard(yardId) {
  if (!yardId) return { qr: '/qr-codes', assemblies: '/assemblies' };
  const wt = `/work-tables/${yardId}`;
  return {
    yard: wt,
    mood: `${wt}?mode=moodboard`,
    palette: `${wt}?mode=palette`,
    takeoff: `${wt}?mode=takeoff`,
    assemblies: '/assemblies',  // AS-1 — its own page, not a Work Table mode
    studio: `${wt}?mode=studio`,
    // DP68 Part 6c — both segments already exist inside the Work Table; only
    // these two route entries were missing, which is why the tiles dimmed.
    assistant: `${wt}?mode=design-assistant`,
    process: `${wt}?mode=process-map`,
    qr: '/qr-codes',
  };
}
